import { useEffect } from 'react';
import { PlanInterval, Subscription, SubscriptionSource } from '../models';
import { useNavigate, useQuery } from '../routes';
import { plan } from '../layout/routes';
import { FeatureQuotaAndCycleMap } from './useGetQuotaAndCycleFromPathParams';

export const useCheckDowngrade = (
  currentSubscriptions: Subscription[],
  featureQuotaAndCycleMap: FeatureQuotaAndCycleMap,
) => {
  const { navigate, replaceQuery } = useNavigate();
  const { get } = useQuery();
  const accountId = get('accountId')!!;

  useEffect(() => {
    if (currentSubscriptions.some(sub => sub.billingInterval !== PlanInterval.MONTH
        && featureQuotaAndCycleMap[sub.feature]?.cycle === PlanInterval.MONTH
        && sub.source === SubscriptionSource.RECURLY)) {
      navigate(
        plan.path,
        replaceQuery({ accountId }),
      );
    }
  }, [currentSubscriptions]);
};
